import React from "react";

function Icon(props: { className: string }) {
  return (
    <svg className={props.className} viewBox="0 0 19.401 19.35">
      <path
        d="M165.573,170.689c-.306-.064-.619-.105-.917-.2a5.342,5.342,0,0,1-3.952-4.4,5.465,5.465,0,0,1,10.785-1.779c.022.128.05.255.075.382v1.064c-.016.082-.032.164-.048.245a5.417,5.417,0,0,1-3.983,4.487c-.291.089-.6.131-.9.194Zm-3.248-5.474a3.775,3.775,0,1,0,3.826-3.766,3.772,3.772,0,0,0-3.826,3.766"
        transform="translate(-152.163 -151.339)"
      />
      <path
        d="M.054,8.823A8.835,8.835,0,0,1,17.523,6.966a.845.845,0,0,1-1.631.436,12.128,12.128,0,0,0-.582-1.663,6.954,6.954,0,0,0-5.5-3.973A7.133,7.133,0,0,0,6.2,15.449c.392.159.808.26,1.215.383a.835.835,0,0,1,.633.861.8.8,0,0,1-.681.778,1.653,1.653,0,0,1-.655-.073A8.742,8.742,0,0,1,.3,10.828a18.011,18.011,0,0,1-.3-2l.054-.008"
        transform="translate(0 0)"
      />
      <path
        d="M92.378,61.142V59.133q0-1.074,0-2.148a.845.845,0,1,1,1.688-.01c.005.624,0,1.248,0,1.872q0,1.507,0,3.015a.874.874,0,0,1-.968.978c-1.07,0-2.141,0-3.211,0a.847.847,0,0,1-.82-1.14.829.829,0,0,1,.787-.548c.8,0,1.6,0,2.4,0,.032,0,.063,0,.119-.007"
        transform="translate(-84.328 -53.152)"
      />
      <path
        d="M248.725,209.66c0-.341,0-.683,0-1.024a.842.842,0,0,1,1.684-.066q.027,1.092,0,2.186a.842.842,0,0,1-1.684-.052c0-.348,0-.7,0-1.044"
        transform="translate(-235.63 -196.83)"
      />
      <path
        d="M249.558,289.212a.831.831,0,0,1-.824-.848.844.844,0,0,1,.838-.842.863.863,0,0,1,.851.856.845.845,0,0,1-.865.834"
        transform="translate(-235.639 -272.385)"
      />
    </svg>
  );
}

export { Icon };
